export default "__VITE_ASSET__RFFB$tKf__"